import React, { createContext, useContext } from 'react';

import { RINGCENTRAL_RECORDS_INITIAL_PAGE, RINGCENTRAL_RECORDS_PAGE_SIZE } from './constants';
import { RingCentralCommunicationType, RingCentralRecordsFiltersType } from './types';

type RingCentralRecordsContextType = {
  items: RingCentralCommunicationType[];
  loading: boolean;
  totalItemsCount: number;
  filters: RingCentralRecordsFiltersType;
  setPage: (page: number) => void;
  setFilters: (filters: Partial<RingCentralRecordsFiltersType>) => void;
};

export const RingCentralRecordsContext = createContext<RingCentralRecordsContextType>({
  items: [],
  loading: false,
  totalItemsCount: 0,
  filters: {
    page: RINGCENTRAL_RECORDS_INITIAL_PAGE,
    pageSize: RINGCENTRAL_RECORDS_PAGE_SIZE,
    search: '',
    source_type: [],
    direction: [],
    matching_status: [],
    media_type: [],
  },
  setPage: () => {
    // Do nothing
  },
  setFilters: () => {
    // Do nothing
  },
});

export const useRingCentralRecordsContext = () => useContext(RingCentralRecordsContext);
